module.exports = __webpack_public_path__ + "media/images/favicon/favicon-32x32-1370f84866c5dcf320521dc69b71129e.png";